var exports = {
  "kL": "MfaScreen.module__container___a3llMH",
  "DD": "MfaScreen.module__title___a3llMH",
  "h_": "MfaScreen.module__description___a3llMH",
  "Zd": "MfaScreen.module__form___a3llMH",
  "_N": "MfaScreen.module__webauthnSection___a3llMH",
  "Hq": "MfaScreen.module__footerButtons___a3llMH",
  "wC": "MfaScreen.module__footerButton___a3llMH",
};

module.exports = exports;
